import React from 'react';
import pkg from '../../../package.json';
import { useBranding } from '../../contexts/BrandingContext';

interface VersionBadgeProps {
  collapsed?: boolean;
}

const VersionBadge: React.FC<VersionBadgeProps> = ({ collapsed }) => {
  const { config: brandingConfig } = useBranding();
  const meta = typeof document !== 'undefined' ? (q: string) => (document.querySelector(`meta[name="${q}"]`) as HTMLMetaElement | null)?.content || '' : () => '';
  const name = brandingConfig ? 'by Assistant Business' : (import.meta.env.VITE_APP_NAME || meta('app:name') || 'AB3');
  const versionFromPkg = (pkg as any)?.version || '';
  const version = versionFromPkg || import.meta.env.VITE_APP_VERSION || meta('app:version') || 'unknown';

  const displayVersion = (() => {
    const parts = version.split('.');
    if (parts.length === 4) return parts.slice(0, 3).join('.');
    return version;
  })();

  const compact = (() => {
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(displayVersion)) {
      const mmdd = displayVersion.slice(5, 10);
      const hhmm = displayVersion.slice(11, 16);
      return `${mmdd} ${hhmm}`;
    }
    if (displayVersion.length > 10) return displayVersion.slice(0, 10);
    return displayVersion;
  })();

  return (
    <div className="sidebar-version" title={`${name} — v${displayVersion}`}>
      {collapsed ? (
        <span className="sidebar-version-short">v{compact}</span>
      ) : (
        <>
          <span className="sidebar-version-name">{name}</span>
          <span className="sidebar-version-dot">•</span>
          <span className="sidebar-version-code">v{displayVersion}</span>
        </>
      )}
    </div>
  );
};

export default VersionBadge;
